import { useEffect, useRef } from "react";

import AdminRoutes from "Routes/Components/Admin";

import { UsePaginatedFetch } from "Hooks/UsePaginatedFetch";

import Loading from "Components/Admin/Loading";
import Section from "Components/Admin/Section";
import Table from "Components/Admin/Table";
import { TableActionLink, withRowLink } from "Components/Admin/TableRowLink";

import { columns, downloadColumns } from "./columns";
import * as S from "./styles";

/*
 * Tela de PENDÊNCIAS do admin — parte 4 (D6/D7/D11, 05/09/2026).
 *
 * Lista mensagem, álbum, cronograma e relatório enviados e ainda não avaliados,
 * e é o destino do alerta do sino. O total daqui e o "Há N itens" do alerta
 * saem da MESMA query no backend (RN13) — calcular nos dois lugares é como o
 * número passa a discordar da lista.
 *
 * O caminho `/admin/pendencias` segue a convenção do projeto (telas do admin
 * vivem sob /admin/* com AdminLayout); o `/user/pendencias` do pedido era
 * indicativo (D7).
 */
const LINK_TITLE = "Abrir a sessão do projeto — Ctrl/Cmd+clique para nova aba";

// A pendência abre a SUB-ABA que a resolve: o `tab` vem do backend, junto com
// a linha, para o front não ter de manter um segundo mapa kind → aba.
const detailPath = (row) =>
  row.project_id
    ? `${AdminRoutes.UpdateProjects.path.replace(":id", row.project_id)}${
        row.tab ? `?tab=${row.tab}` : ""
      }`
    : null;

const PendingApprovals = () => {
  const cancelRequest = useRef(false);

  const {
    setStartFetch,
    progress,
    requestInProgress,
    firstResponseReceived,
    data,
  } = UsePaginatedFetch({
    method: "post",
    path: "/projects/pending-approvals",
    body: {},
    responseAccessor: "pending_items",
    pageSize: 1000,
    cancelRequest: cancelRequest,
  });

  useEffect(() => {
    if (!requestInProgress && !firstResponseReceived) setStartFetch(true);
    // eslint-disable-next-line
  }, []);

  return (
    <Section>
      <S.SectionWrapper>
        <S.Wrapper>
          {requestInProgress && !firstResponseReceived ? (
            <Loading />
          ) : (
            <Table
              name="Pendências"
              data={data}
              columns={[
                ...withRowLink(columns, {
                  accessor: "project_name",
                  to: detailPath,
                  rowId: (row) => row.project_id,
                }),
                {
                  Header: "Ações",
                  accessor: "actions",
                  noSearch: true,
                  width: "70px",
                  Cell: ({ cell }) => (
                    <TableActionLink
                      to={detailPath(cell.row.original)}
                      title={LINK_TITLE}
                    />
                  ),
                },
              ]}
              downloadColumns={downloadColumns}
              disableDownloadButton={requestInProgress}
            />
          )}

          {!requestInProgress && firstResponseReceived && !data.length ? (
            <span>Nenhuma pendência de aprovação.</span>
          ) : null}

          {requestInProgress && progress ? (
            <span>Carregando {progress}%...</span>
          ) : null}
        </S.Wrapper>
      </S.SectionWrapper>
    </Section>
  );
};

export default PendingApprovals;
